import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { XCircleblack } from "../../../Components/IconComponents";
import "./BlockPopUp.css";
import BlockDetails from "./BlockDetails";
import AffectedPopUpDetails from "./DistrictBlockDetails";
import { ThemeContext } from "../../..";
import FloodDashboardIcon from "../../../Components/IconComponents/FloodDashboardIcon";

const BlockPopUp = (props) => {
  const { title, show, handleToggle, component } = props;

  return (
    <Modal
      show={show}
      onHide={handleToggle}
      className="block__modal__popup"
      size="md"
      centered
    >
      <div className="avd-popup-header">
        <div className="avd-popup-header-left">
          <div className="avd-popup-logo">
            <FloodDashboardIcon style={{ color: "#fff", fontSize: "18px" }} />
          </div>
          <div style={{ minWidth: 0 }}>
            <div className="avd-popup-overline">Flood Impact Zone</div>
            <div className="avd-popup-title-text">{title}</div>
          </div>
        </div>
        <button className="blockpopup-cross_mark" onClick={handleToggle}>
          ✕
        </button>
      </div>
      <Modal.Body>{component}</Modal.Body>
    </Modal>
  );
};

export default BlockPopUp;
